(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gatedrop-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gd-fit-heading')) {
    customElements.define(
      'gd-fit-heading',
      class extends HTMLElement {
        connectedCallback() {
          this.heading = this.querySelector('h1');
          if (!this.heading) return;
          this.fit = () => {
            if (!this.isConnected) return;
            const width = this.clientWidth;
            const natural = this.heading.offsetWidth;
            if (!width || !natural) return;
            const scale = Math.min(1, width / natural);
            this.style.setProperty('--heading-scale', String(scale));
            this.style.height = this.heading.offsetHeight * scale + 'px';
          };
          this.schedule = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(this.fit);
          };
          this.observer = new ResizeObserver(this.schedule);
          this.observer.observe(this);
          this.observer.observe(this.heading);
          this.mutations = new MutationObserver(this.schedule);
          this.mutations.observe(this.heading, { subtree: true, childList: true, characterData: true });
          window.addEventListener('resize', this.schedule);
          document.fonts?.addEventListener('loadingdone', this.schedule);
          document.fonts?.ready.then(() => this.isConnected && this.schedule());
          this.fit();
        }
        disconnectedCallback() {
          this.observer?.disconnect();
          this.mutations?.disconnect();
          cancelAnimationFrame(this.frame);
          window.removeEventListener('resize', this.schedule);
          document.fonts?.removeEventListener('loadingdone', this.schedule);
        }
      },
    );
  }

  if (!customElements.get('gd-hero-slideshow')) {
    customElements.define(
      'gd-hero-slideshow',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.index = 0;
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
          this.paused = this.reduced.matches;
          this.pauseButton = this.querySelector('[data-pause]');
          this.show = (index) => {
            this.index = (index + this.slides.length) % this.slides.length;
            this.slides.forEach((slide, i) => {
              slide.classList.toggle('is-active', i === this.index);
              slide.setAttribute('aria-hidden', String(i !== this.index));
            });
            this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
          };
          this.stop = () => {
            clearInterval(this.timer);
          };
          this.start = () => {
            this.stop();
            if (
              this.slides.length > 1 &&
              this.dataset.autoplay === 'true' &&
              !this.paused &&
              !this.reduced.matches &&
              !document.hidden &&
              !this.matches(':hover') &&
              !this.contains(document.activeElement)
            ) {
              this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.delay) || 5000);
            }
          };
          this.updatePause = () => {
            if (this.pauseButton) {
              this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
              this.pauseButton.setAttribute(
                'aria-label',
                this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel,
              );
            }
          };
          this.dots.forEach((dot, i) =>
            dot.addEventListener(
              'click',
              () => {
                this.show(i);
                this.start();
              },
              options,
            ),
          );
          this.pauseButton?.addEventListener(
            'click',
            () => {
              this.paused = !this.paused;
              this.updatePause();
              this.start();
            },
            options,
          );
          this.addEventListener('mouseenter', this.stop, options);
          this.addEventListener('mouseleave', this.start, options);
          this.addEventListener('focusin', this.stop, options);
          this.addEventListener('focusout', () => setTimeout(() => this.isConnected && this.start(), 0), options);
          this.addEventListener(
            'keydown',
            (event) => {
              if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
                event.preventDefault();
                this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
                this.dots[this.index]?.focus();
              }
            },
            options,
          );
          document.addEventListener('visibilitychange', this.start, options);
          this.reduced.addEventListener(
            'change',
            () => {
              if (this.reduced.matches) this.paused = true;
              this.updatePause();
              this.start();
            },
            options,
          );
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              const i = this.slides.findIndex(
                (slide) =>
                  slide.dataset.shopifyEditorBlock &&
                  JSON.parse(slide.dataset.shopifyEditorBlock).id === event.detail.blockId,
              );
              if (i >= 0) {
                this.paused = true;
                this.show(i);
                this.updatePause();
                this.stop();
              }
            },
            options,
          );
          this.updatePause();
          this.start();
        }
        disconnectedCallback() {
          this.stop?.();
          this.abort?.abort();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-cart-page"] && !Shopify.designMode) return;
  try {
    
  if (!window.gd2CartInstalled) {
    window.gd2CartInstalled = true;
    let busy = false;
    const send = async (path, body) => {
      const response = await fetch((window.Shopify?.routes?.root || '/') + path, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      if (!response.ok) throw Error(data.description || data.message || 'Unable to update cart. Please try again.');
      return data;
    };
    // Re-render Shopify's authoritative totals and lines without navigating away.
    async function refreshCart(section) {
      const wrapper = section.closest('[id^="shopify-section-"]');
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(root + 'cart', window.location.origin);
      url.searchParams.set('section_id', wrapper.id.replace('shopify-section-', ''));
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw Error('Unable to display the updated cart. Please try again.');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = html.getElementById(wrapper.id);
      if (!next?.querySelector('.gd2-cart')) throw Error('Unable to display the updated cart. Please try again.');
      wrapper.dispatchEvent(new CustomEvent('shopify:section:unload', { bubbles: true }));
      wrapper.replaceWith(next);
      setupMobileCartCheckout();
      const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        document.querySelectorAll('cart-count').forEach(count => { count.textContent = cart.item_count; });
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      }
    }
    const normalizedProperties = properties => JSON.stringify(
      Object.entries(properties || {}).filter(([, value]) => value !== '' && value != null).sort(([a], [b]) => a.localeCompare(b))
    );
    // Always fetch current keys before edits: discounts can split or rekey Shopify lines.
    async function change(control, kind) {
      const section = control.closest('.gd2-cart');
      if (!section || busy) return;
      busy = true;
      const error = section.querySelector('.gd2-error');
      error.hidden = true;
      const buttons = [...section.querySelectorAll('button, input[data-gd2-input]')];
      buttons.forEach((b) => (b.disabled = true));
      try {
        const note = section.querySelector('[name="note"]');
        if (note) await send('cart/update.js', { note: note.value });
        if (kind === 'add') {
          const item = { id: Number(control.dataset.gd2Add), quantity: 1 };
          if (control.dataset.plan) item.selling_plan = Number(control.dataset.plan);
          await send('cart/add.js', { items: [item] });
        } else {
          const quantity = kind === 'input' ? Number(control.value) : Number(control.dataset.quantity);
          if (!Number.isInteger(quantity) || quantity < 0) throw Error('Please enter a valid quantity.');
          const group = control.closest('[data-cart-group]');
          const root = window.Shopify?.routes?.root || '/';
          const readCart = async () => {
            const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
            if (!response.ok) throw Error('Unable to read cart. Please try again.');
            return response.json();
          };
          const cart = await readCart();
          // Variant, purchase plan and properties survive Shopify discount rekeying.
          const propertiesKey = normalizedProperties(JSON.parse(group.dataset.properties || '{}'));
          const members = cart.items.filter(i =>
            Number(i.variant_id) === Number(group.dataset.variant) &&
            Number(i.selling_plan_allocation?.selling_plan.id || 0) === Number(group.dataset.sellingPlan) &&
            normalizedProperties(i.properties) === propertiesKey
          );
          if (!members.length) {
            await refreshCart(section);
            return;
          }
          if (kind === 'switch') {
            const original = members[0];
            const properties = normalizedProperties(original.properties);
            const oldPlan = original.selling_plan_allocation?.selling_plan.id || null;
            const target = control.dataset.plan ? Number(control.dataset.plan) : null;
            let current = cart;
            for (let attempt = 0; attempt < cart.items.length + 2; attempt++) {
              const index = current.items.findIndex(
                (i) =>
                  i.variant_id === original.variant_id &&
                  (i.selling_plan_allocation?.selling_plan.id || null) === oldPlan &&
                  normalizedProperties(i.properties) === properties,
              );
              if (index < 0) break;
              current = await send('cart/change.js', {
                line: index + 1,
                quantity: current.items[index].quantity,
                selling_plan: target,
              });
            }
          } else {
            // Positional quantities also work when discount apps rewrite line keys.
            const memberKeys = new Set(members.map(item => item.key));
            const updates = cart.items.map(item =>
              memberKeys.has(item.key) ? (item === members[0] ? quantity : 0) : item.quantity
            );
            try {
              await send('cart/update.js', { updates });
            } catch (updateError) {
              // Shopify can apply removal but report a stale-line error after discounts rekey.
              // Confirm the requested state before deciding whether it really failed.
              const latest = await readCart();
              const actualQuantity = latest.items.filter(i =>
                Number(i.variant_id) === Number(group.dataset.variant) &&
                Number(i.selling_plan_allocation?.selling_plan.id || 0) === Number(group.dataset.sellingPlan) &&
                normalizedProperties(i.properties) === propertiesKey
              ).reduce((total, item) => total + item.quantity, 0);
              if (actualQuantity !== quantity) throw updateError;
            }
          }
        }
        await refreshCart(section);
      } catch (e) {
        error.textContent = e.message;
        error.hidden = false;
      } finally {
        busy = false;
        buttons.forEach((b) => (b.disabled = false));
      }
    }
    document.addEventListener('click', (e) => {
      const c = e.target.closest('[data-gd2-change],[data-gd2-add],[data-gd2-switch]');
      if (c) {
        e.preventDefault();
        change(c, c.hasAttribute('data-gd2-add') ? 'add' : c.hasAttribute('data-gd2-switch') ? 'switch' : 'change');
      }
    });
    document.addEventListener('change', (e) => {
      if (e.target.matches('[data-gd2-input]')) change(e.target, 'input');
    });
  }

  // The fixed mobile bar slides away only as the real checkout button enters view.
  function setupMobileCartCheckout() {
    document.querySelectorAll('.gd2-cart').forEach((section) => {
      const bar = section.querySelector('.gd2-mobile-checkout'),
        checkout = section.querySelector('.gd2-checkout');
      if (!bar || !checkout || bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      // Each editor section owns its listeners and observers.
      const controller = new AbortController();
      const signal = controller.signal;
      const media = window.matchMedia('(max-width:740px)');
      const update = () => {
        bar.hidden = !media.matches;
        if (!media.matches) return;
        const rect = checkout.getBoundingClientRect(),
          height = bar.offsetHeight;
        const distance = Math.max(64, rect.height + 24);
        const progress = Math.max(0, Math.min(1, (window.innerHeight - rect.top) / distance));
        bar.style.transform = 'translateY(' + progress * (height + 12) + 'px)';
        bar.style.visibility = progress >= 1 ? 'hidden' : 'visible';
        bar.inert = progress >= 1;
      };
      let frame = 0;
      const schedule = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          if (section.isConnected) update();
        });
      };
      window.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      const observer = new IntersectionObserver(schedule);
      observer.observe(checkout);
      const resize = new ResizeObserver(schedule);
      resize.observe(section);
      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          if (event.target.contains(section)) {
            controller.abort();
            observer.disconnect();
            resize.disconnect();
            cancelAnimationFrame(frame);
          }
        },
        { signal },
      );
      update();
    });
  }
  setupMobileCartCheckout();
  document.addEventListener('shopify:section:load', setupMobileCartCheckout);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-product-display"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gd-product-display'))
    customElements.define(
      'gd-product-display',
      class extends HTMLElement {
        // Initialize state and abortable listeners when a panel enters the document.
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          this.abort = new AbortController();
          const signal = this.abort.signal;
          this.q = (s) => this.querySelector(s);
          this.qa = (s) => [...this.querySelectorAll(s)];
          this.variants = JSON.parse(this.q('[data-gdp-variants]').textContent);
          this.form = this.q('.gdp-form');
          this.v = this.variants.find((v) => String(v.id) === this.form.elements.id.value) || this.variants[0];
          this.plan = this.v.plans.length ? String(this.v.plans[0].id) : '';
          this.busy = false;
          this.slide = 0;
          // Reuse one currency formatter per product panel.
          this.currencyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: this.dataset.currency || 'USD',
          });
          this.money = (n) => this.currencyFormatter.format(n / 100);
          this.addEventListener(
            'gatedrop:variant-selected',
            (e) => {
              const next = this.variants.find((v) => String(v.id) === String(e.detail.variantId));
              if (!next) return;
              this.v = next;
              this.render();
              if (next.media) {
                const index = this.qa('[data-media]').findIndex((m) => m.dataset.media === String(next.media));
                if (index >= 0) this.showMedia(index);
              }
              if (this.dataset.productPage === 'true') {
                const url = new URL(location.href);
                url.searchParams.set('variant', next.id);
                history.replaceState({}, '', url);
              }
            },
            { signal },
          );
          this.addEventListener(
            'change',
            (e) => {
              if (e.target === this.form.elements.quantity) {
                const input = e.target;
                input.value = Math.max(1, parseInt(input.value, 10) || 1);
                this.q('[data-quantity-step="-1"]').disabled = Number(input.value) <= 1;
              }
              if (e.target.matches('.gdp-plan input')) {
                this.plan = e.target.value;
                this.render();
              }
            },
            { signal },
          );
          this.addEventListener(
            'click',
            (e) => {
              const option = e.target.closest('[data-product-target]');
              if (option) {
                e.preventDefault();
                e.stopPropagation();
                if (this.busy) return;
                const next = this.closest('[data-gdp-products]').querySelector(
                  '[data-product-id="' + option.dataset.productTarget + '"]',
                );
                if (!next || next === this) return;
                const position = option.getBoundingClientRect().top;
                next.form.elements.quantity.value = this.form.elements.quantity.value;
                next.form.elements.quantity.dispatchEvent(new Event('change', { bubbles: true }));
                // Carry the customer's current flavor into the destination pouch, rather than its previous selection.
                const selectedFlavor = this.q('.gd-flavor input:checked')?.closest('.gd-flavor')
                  .querySelector('.gd-flavor__copy b')?.textContent.trim().toLowerCase();
                const matchingInput = next.qa('.gd-flavor input').find(input =>
                  input.closest('.gd-flavor').querySelector('.gd-flavor__copy b')?.textContent.trim().toLowerCase() === selectedFlavor
                );
                const matchingVariant = matchingInput && next.variants.find(v => String(v.id) === matchingInput.value);
                if (matchingVariant) next.v = matchingVariant;
                next.qa('.gd-flavor input').forEach(input => { input.checked = input.value === String(next.v.id); });
                next.plan = this.plan;
                next.render();
                if (next.v.media) {
                  const mediaIndex = next.qa('[data-media]').findIndex(media => media.dataset.media === String(next.v.media));
                  if (mediaIndex >= 0) next.showMedia(mediaIndex);
                }
                this.qa('video').forEach((video) => video.pause());
                this.q('.gdp-sticky').hidden = true;
                this.hidden = true;
                next.hidden = false;
                if (this.dataset.productPage === 'true') {
                  const url = new URL(option.href, location.origin);
                  url.searchParams.set('variant', next.v.id);
                  if (next.plan) url.searchParams.set('selling_plan', next.plan);
                  const preview = new URL(location.href).searchParams.get('preview_theme_id');
                  if (preview) url.searchParams.set('preview_theme_id', preview);
                  history.replaceState({}, '', url);
                  document.title = next.q('.gdp-title').textContent.trim() + ' – ' + 'GateDrop';
                  const canonical = document.querySelector('link[rel="canonical"]');
                  if (canonical) canonical.href = option.href;
                }
                const active = next.q('[data-product-target="' + option.dataset.productTarget + '"]');
                active.focus({ preventScroll: true });
                window.scrollBy(0, active.getBoundingClientRect().top - position);
                return;
              }
              const step = e.target.closest('[data-quantity-step]');
              if (step) {
                const input = this.form.elements.quantity;
                input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.quantityStep));
                input.dispatchEvent(new Event('change', { bubbles: true }));
              }
              const thumb = e.target.closest('[data-thumb]');
              if (thumb)
                this.showMedia(this.qa('[data-media]').findIndex((m) => m.dataset.media === thumb.dataset.thumb));
              if (e.target.closest('.gdp-next')) this.showMedia(this.slide + 1);
              if (e.target.closest('.gdp-prev')) this.showMedia(this.slide - 1);
              if (e.target.closest('[data-sticky-add]')) this.form.requestSubmit(this.q('.gdp-main-atc'));
            },
            { signal },
          );
          this.q('.gdp-media').addEventListener(
            'keydown',
            (e) => {
              if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                e.preventDefault();
                this.showMedia(this.slide + (e.key === 'ArrowRight' ? 1 : -1));
              }
            },
            { signal },
          );
          this.q('.gdp-media').addEventListener(
            'touchstart',
            (e) => {
              this.touch = { x: e.touches[0].clientX, y: e.touches[0].clientY };
            },
            { passive: true, signal },
          );
          this.q('.gdp-media').addEventListener(
            'touchend',
            (e) => {
              if (!this.touch) return;
              const dx = e.changedTouches[0].clientX - this.touch.x,
                dy = e.changedTouches[0].clientY - this.touch.y;
              if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.showMedia(this.slide + (dx < 0 ? 1 : -1));
              this.touch = null;
            },
            { passive: true, signal },
          );
          this.form.addEventListener(
            'submit',
            async (e) => {
              e.preventDefault();
              if (this.busy || !this.v.available) return;
              this.busy = true;
              const error = this.q('.gdp-error');
              error.hidden = true;
              this.qa('.gdp-button').forEach((b) => {
                b.disabled = true;
                b.setAttribute('aria-busy', 'true');
              });
              try {
                const body = { id: this.v.id, quantity: Number(this.form.elements.quantity.value) };
                if (this.plan) body.selling_plan = Number(this.plan);
                const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
                const res = await fetch(root + 'cart/add.js', {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ items: [body] }),
                });
                const data = await res.json();
                if (!res.ok)
                  throw Error(data.description || data.message || 'Unable to add this item. Please try again.');
                location.assign(this.dataset.cart);
              } catch (err) {
                error.textContent = err.message;
                error.hidden = false;
                error.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                this.busy = false;
                this.render();
                this.qa('.gdp-button').forEach((b) => b.removeAttribute('aria-busy'));
              }
            },
            { signal },
          );
          // At most one layout read per frame; hidden product panels do no scroll work.
          const mainAtc = this.q('.gdp-main-atc'),
            sticky = this.q('.gdp-sticky');
          const updateSticky = () => {
            if (this.hidden) {
              sticky.hidden = true;
              return;
            }
            const rect = mainAtc.getBoundingClientRect();
            sticky.hidden = rect.bottom >= 0 || this.getBoundingClientRect().bottom <= 0;
          };
          const scheduleSticky = () => {
            if (this.stickyFrame || this.hidden) return;
            this.stickyFrame = requestAnimationFrame(() => {
              this.stickyFrame = 0;
              updateSticky();
            });
          };
          this.observer = new IntersectionObserver(scheduleSticky, { threshold: 0 });
          this.observer.observe(mainAtc);
          window.addEventListener('scroll', scheduleSticky, { passive: true, signal });
          window.addEventListener('resize', scheduleSticky, { passive: true, signal });
          this.q('[data-quantity-step="-1"]').disabled = true;
          this.render();
          updateSticky();
        }
        // Hide inactive media and pause videos so hidden panels consume no playback work.
        showMedia(index) {
          const slides = this.qa('[data-media]');
          if (!slides.length || (index < 0 && this.slide === undefined)) return;
          index = (index + slides.length) % slides.length;
          this.slide = index;
          slides.forEach((s, i) => {
            s.hidden = i !== index;
            if (i !== index) s.querySelectorAll('video').forEach((v) => v.pause());
          });
          this.qa('[data-thumb]').forEach((b, i) => b.setAttribute('aria-pressed', String(i === index)));
        }
        // Keep price labels, plan radios, sticky CTA and the submitted variant in sync.
        render() {
          const v = this.v;
          if (this.plan && !v.plans.some((p) => String(p.id) === this.plan))
            this.plan = v.plans.length ? String(v.plans[0].id) : '';
          const p = v.plans.find((p) => String(p.id) === this.plan);
          const variantChanged = this.form.elements.id.value !== String(v.id);
          this.form.elements.id.value = v.id;
          // Notify variant listeners only for an actual variant change, then restore the custom plan selection.
          if (variantChanged) this.form.elements.id.dispatchEvent(new Event('change', { bubbles: true }));
          this.q('[data-gdp-selling-plan]').value = this.plan;
          this.q('[data-gdp-selling-plan]').disabled = !this.plan;
          this.q('[data-price]').textContent = this.money(v.price);
          this.q('[data-compare]').hidden = !(v.compare > v.price);
          this.q('[data-compare]').textContent = this.money(v.compare);
          this.q('[data-saving]').hidden = !(v.compare > v.price);
          this.q('[data-saving]').textContent = 'Save ' + this.money(v.compare - v.price);
          this.q('[data-unit]').textContent = this.money(v.price / Number(this.dataset.count));
          this.q('[data-sku]').textContent = v.sku || '—';
          this.q('[data-stock]').textContent = v.available ? 'In stock' : this.dataset.soldLabel;
          this.q('[data-one-price]').textContent = this.money(v.price);
          this.qa('[data-plan-option]').forEach((el) => {
            const allocation = v.plans.find((a) => String(a.id) === el.dataset.planOption);
            el.hidden = !allocation;
            if (!allocation) return;
            el.querySelector('[data-plan-price]').textContent = this.money(allocation.price);
            el.querySelector('[data-plan-first]').textContent = this.money(allocation.price);
            el.querySelector('[data-plan-renewal]').textContent = this.money(allocation.renewal);
            const discount = Math.round((1 - allocation.price / v.price) * 100);
            el.querySelector('[data-plan-discount]').textContent = discount > 0 ? 'Save ' + discount + '%' : '';
            el.querySelector('[data-plan-discount]').hidden = discount <= 0;
          });
          this.qa('.gdp-plan input').forEach((i) => (i.checked = i.value === this.plan));
          const price = p ? p.price : v.price;
          const label = v.available ? (p ? this.dataset.subLabel : this.dataset.addLabel) : this.dataset.soldLabel;
          this.q('.gdp-main-atc').textContent = label;
          this.q('[data-sticky-add]').textContent = label;
          this.q('[data-sticky-description]').textContent =
            v.title + ' · ' + this.money(price) + (p ? ' · Auto-Restock' : '');
          this.qa('.gdp-button').forEach((b) => (b.disabled = !v.available || this.busy));
        }
        // Release listeners when this panel leaves the DOM; never override initialization.
        disconnectedCallback() {
          this.abort?.abort();
          this.observer?.disconnect();
          cancelAnimationFrame(this.stickyFrame);
          this.stickyFrame = 0;
          this.ready = false;
        }
      },
    );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('gd-mobile-cart-switch')) {
    customElements.define(
      'gd-mobile-cart-switch',
      class extends HTMLElement {
        connectedCallback() {
          this.sync = () => {
            const count = this.querySelector('cart-count');
            if (count) this.dataset.filled = String((parseInt(count.textContent, 10) || 0) > 0);
          };
          this.sync();
          this.observer = new MutationObserver(this.sync);
          this.observer.observe(this, { childList: true, subtree: true, characterData: true });
        }
        disconnectedCallback() {
          this.observer?.disconnect();
        }
      },
    );
  }

  if (!window.gdBuyInstalled) {
    window.gdBuyInstalled = true;
    let busy = false;
    const root = () => window.Shopify?.routes?.root || '/';
    // Centralize cart request error handling. A failed write leaves the offer retryable.
    const request = async (path, body) => {
      const response = await fetch(root() + path, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : {}),
      });
      const data = await response.json();
      if (!response.ok)
        throw new Error(data.description || data.message || 'Unable to update your cart. Please try again.');
      return data;
    };
    document.addEventListener(
      'click',
      async (event) => {
        const button = event.target.closest('[data-gd-buy]');
        if (!button) return;
        event.preventDefault();
        if (busy) return;
        busy = true;
        const buttons = [...document.querySelectorAll('[data-gd-buy]')];
        buttons.forEach((b) => {
          b.disabled = true;
          b.setAttribute('aria-busy', 'true');
        });
        document.querySelector('.gd-buy-error')?.remove();
        try {
          if (button.dataset.gdBuyItems) {
          const offerItems = JSON.parse(button.dataset.gdBuyItems || '[]');
          if (offerItems.length !== 2 || offerItems.some(item => !item.id || !item.selling_plan || !item.available))
            throw new Error('This two-flavor Auto-Restock offer is unavailable. Please select a product from the shop.');
          const cart = await request('cart.js');
          // Ensure one of each subscription flavor without duplicating repeat clicks or reducing existing quantities.
          const missingItems = offerItems.filter(offer => !cart.items.some(item =>
            Number(item.variant_id) === offer.id && Number(item.selling_plan_allocation?.selling_plan?.id) === offer.selling_plan
          )).map(({ id, quantity, selling_plan }) => ({ id, quantity, selling_plan }));
          if (missingItems.length) await request('cart/add.js', { items: missingItems });
          const updatedCart = await request('cart.js');
          if (!offerItems.every(offer => updatedCart.items.some(item =>
            Number(item.variant_id) === offer.id && Number(item.selling_plan_allocation?.selling_plan?.id) === offer.selling_plan
          ))) throw new Error('Please check your cart and try again.');
          } else {
          let offer = document.querySelector('[data-gd-offer]');
          if (!offer) {
            const response = await fetch(root(), { credentials: 'same-origin', cache: 'no-store' });
            if (!response.ok) throw new Error('Unable to load the offer. Please try again.');
            offer = new DOMParser()
              .parseFromString(await response.text(), 'text/html')
              .querySelector('[data-gd-offer]');
          }
          const variant = Number(offer?.dataset.variant),
            plan = Number(offer?.dataset.plan),
            quantity = Number(offer?.dataset.quantity);
          if (!variant || !plan || !Number.isInteger(quantity) || quantity < 1)
            throw new Error('This offer is unavailable. Please select a product from the shop.');
          let cart = await request('cart.js');
          const matches = (item) =>
            Number(item.variant_id) === variant && Number(item.selling_plan_allocation?.selling_plan?.id) === plan;
          const items = cart.items.filter(matches);
          if (!items.length) {
            await request('cart/add.js', { items: [{ id: variant, quantity, selling_plan: plan }] });
          } else {
            let remaining = quantity;
            const updates = {};
            items.forEach((item, index) => {
              const target = index === items.length - 1 ? remaining : Math.min(item.quantity, remaining);
              remaining -= target;
              if (target !== item.quantity) updates[item.key] = target;
            });
            if (Object.keys(updates).length) await request('cart/update.js', { updates });
          }
          cart = await request('cart.js');
          if (cart.items.filter(matches).reduce((sum, item) => sum + item.quantity, 0) !== quantity)
            throw new Error('Please check the quantity in your cart and try again.');
          }
          window.location.assign(root() + 'cart');
        } catch (error) {
          const message = document.createElement('div');
          message.className = 'gd-buy-error';
          message.setAttribute('role', 'alert');
          message.textContent = error.message;
          document.body.append(message);
        } finally {
          busy = false;
          buttons.forEach((b) => {
            b.disabled = false;
            b.removeAttribute('aria-busy');
          });
        }
      },
      true,
    );
  }

  } catch(e) { console.error(e); }
})();
})();
